import { Controller } from "@hotwired/stimulus"

// Reveals a card's rename form and puts the cursor in it.
//
// The form lives OUTSIDE the dropdown that opens it. A form inside a Bootstrap
// dropdown is dismissed the moment you click into the input — the menu closes
// on any click within it — so the field could never actually be typed in.
export default class extends Controller {
  static targets = ["form", "input"]

  open() {
    this.formTarget.hidden = false
    // select(), not focus(): renaming is usually replacing, and an existing
    // name selected is one keystroke from gone.
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  close() {
    this.formTarget.hidden = true
    // Discard the edit, so reopening starts from what is actually saved
    // rather than from an abandoned draft.
    this.inputTarget.value = this.inputTarget.defaultValue
  }

  // Escape closes it, the same as any other transient editor.
  keydown(event) {
    if (event.key === "Escape") this.close()
  }

  connect() {
    this.onKeydown = this.keydown.bind(this)
    this.element.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.onKeydown)
  }
}
